
<!--<div>
    <top-bar-home></top-bar-home>
</div>-->

<!-- Start Banner -->
<div id="banner" class="parallax-bg" style="background-image:url(../../../assets/img/banner/1.jpg);">
    <div class="container" style="padding-bottom:100px">
        <div class="row">
            <div class="col-xs-12 col-sm-7 col-md-6">
                <div class="banner-content wow fadeInLeft" data-wow-delay="0.4s">
                    <div style="line-height:5;">
                        <h1>Introducing a brand new app for holy travel<br /> <strong>Nesiya Tova</strong></h1>
                        <p>Nesiya Tova was the brain-child of frequent travelers who spent over 20 years collecting and documenting their travel data and then re-arranging it in a way that could be used by anyone planning to visit the same spots. We have an enormous collection of information on everything you need to know before going to visit מקומות הקדושים , including detailed information about each tzaddik, location, and even what teffilos to say where. If you're planning a trip like this, Nesiya Tova is the way to go. Literally.</p>
                        <p>Our in-app algorithm allows travelers to select a route directly from our list, and ensures efficient travel plans. Routes will include everything you need to know in order to have a successful journey. We'll provide you with information regarding airports, hotels, and car rentals, as well as the actual route directions and information. Once you have selected a route, we made it possible for you to then transfer this selection to your GPS maps system and access this information in-app, even when offline on location. </p>
                        <a href="https://itunes.apple.com/us/app/nesiya-tova/id1280470476?mt=8" class="btn btn-default"><i class="fa fa-apple"></i> App Store</a>
                        <a href="http://play.google.com/store/apps/details?id=com.NesiyaTova" class="btn btn-default"><i class="fa fa-play"></i> Google Play</a>
                        <a routerLink="/ads" class="btn btn-default"><i class="fa fa-cloud"></i> ADS</a>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-5 pull-right">
                <div class="single-img text-right hidden-xs wow fadeInRight" data-wow-delay="0.8s">
                   <img src="../../../assets/img/banner/2.png" alt="">
                </div>
            </div>

        </div>
    </div>
</div>
<!-- End Banner -->
<!-- Start How it Works -->
<section id="howitworks" class="section-padding">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="section-title text-center">
                    <h1>Included Features</h1>
                    <p>For detailed instructions see "How It Works" page in the app</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-6 mb-5 mb-md-0">
                <div class="single-img wow fadeInLeft">
                    <img src="../../../assets/img/howitworks/1.png" alt="">
                </div>
            </div>

            <div class="col-xs-12 col-sm-6">
                <div class="features-block">
                    <div class="features-list wow fadeInRight">
                        <div class="icon">
                            <i class="fa fa-eye" aria-hidden="true"></i>
                        </div>
                        <div class="feature-info">
                            <h3>High Quality Viewing</h3>
                            <p>our state-of-the-art app features clean and clear design, is super user-friendly, and compatible with other GPS map apps.</p>
                        </div>
                    </div>

                    <div class="features-list wow fadeInRight">
                        <div class="icon">
                            <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                        </div>
                        <div class="feature-info">
                            <h3>Offline</h3>
                            <p>We built our app to be available even in areas where internet connection is not available. A lot of the small towns lack internet accessibility, but because our app will install all the mapping information directly onto your phone, you'll still be able to get where you want to go. Google Maps has a download option that will enable you to access your route with navigation there too while offline.</p>
                        </div>
                    </div>

                    <div class="features-list wow fadeInRight">
                        <div class="icon">
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </div>
                        <div class="feature-info">
                            <h3>Easy searching</h3>
                            <p>travelers can search by town or by tzaddik and find detailed information regarding location access and availability.</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="gap">
                </div>
            </div>
        </div>

        <div class="row">
           
                <div class="col-xs-12 col-sm-6">
                    <div class="features-block">
                        <div class="features-list wow fadeInRight">
                            <div class="icon">
                                <i class="fa fa-file" aria-hidden="true"></i>
                            </div>
                            <div class="feature-info">
                                <h3>Beautiful Display Page</h3>
                                <p>Access an enormous collection of information on everything you need to know before going to visit מקומות הקדושים, including detailed information about each tzaddik, location, and even what teffilos to say where. If you're planning a trip like this, Nesiya Tova is the way to go. Literally.</p>
                            </div>
                        </div>

                        <div class="features-list wow fadeInRight">
                            <div class="icon">
                                <i class="fa fa-info" aria-hidden="true"></i>
                            </div>
                            <div class="feature-info">
                                <h3>View On Map</h3>
                                <p>We know you like options, and we're here to help. We know you may be more familiar with the interface of real maps, so we created a way for you to view our entire data (all types of places) directly in a Map with all the places marked on it! You can search for places directly on the map, and create your travel route.</p>
                            </div>
                        </div>

                        <div class="features-list wow fadeInRight">
                            <div class="icon">
                                <i class="fa fa-map-marker" aria-hidden="true"></i>
                            </div>
                            <div class="feature-info">
                                <h3>Routing Options</h3>
                                <p>Our in-app algorithm allows travelers to select a route directly from our list, and ensures efficient travel plans. Routes will include everything you need to know in order to have a successful journey. We'll provide you with information regarding airports, hotels, and car rentals, as well as the actual route directions and information. Once you have selected a route, we made it possible for you to then transfer this selection to your GPS maps system and access this information in-app, even when offline on location.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <div class="single-img wow fadeInLeft">
                        <img src="../../../assets/img/howitworks/2.png" alt="">
                    </div>
                </div>
        </div>

        <div class="row">
            <div class="d-none">
                <div class="col-xs-12 col-sm-6">
                    <div class="single-img wow fadeInLeft">
                        <img src="../../../assets/img/howitworks/2.png" alt="">
                    </div>


                    <div class="col-xs-12 col-sm-6">
                        <div class="features-block">
                            <div class="features-list wow fadeInRight">
                                <div class="icon">
                                    <i class="fa fa-file" aria-hidden="true"></i>
                                </div>
                                <div class="feature-info">
                                    <h3>Beautiful Display Page</h3>
                                    <p>Access an enormous collection of information on everything you need to know before going to visit מקומות הקדושים, including detailed information about each tzaddik, location, and even what teffilos to say where. If you're planning a trip like this, Nesiya Tova is the way to go. Literally.</p>
                                </div>
                            </div>

                            <div class="features-list wow fadeInRight">
                                <div class="icon">
                                    <i class="fa fa-info" aria-hidden="true"></i>
                                </div>
                                <div class="feature-info">
                                    <h3>View On Map</h3>
                                    <p>We know you like options, and we're here to help. We know you may be more familiar with the interface of real maps, so we created a way for you to view our entire data (all types of places) directly in a Map with all the places marked on it (your current location will be in the center of the map)! You can search for places directly on the map, and create your travel route.</p>
                                </div>
                            </div>

                            <div class="features-list wow fadeInRight">
                                <div class="icon">
                                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                                </div>
                                <div class="feature-info">
                                    <h3>Routing Options</h3>
                                    <p>Our in-app algorithm allows travelers to select a route directly from our list, and ensures efficient travel plans. Routes will include everything you need to know in order to have a successful journey. We'll provide you with information regarding airports, hotels, and car rentals, as well as the actual route directions and information. Once you have selected a route, we made it possible for you to then transfer this selection to your GPS maps system and access this information in-app, even when offline on location.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-xs-12">
                <div class="gap">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-6 mb-5 mb-md-0">
                <div class="single-img wow fadeInLeft">
                    <img src="../../../assets/img/howitworks/3.png" alt="">
                </div>
            </div>
            <div class="col-xs-12 col-sm-6">
                <div class="features-block">
                    <div class="features-list wow fadeInRight">
                        <div class="icon">
                            <i class="fa fa-map-signs" aria-hidden="true"></i>
                        </div>
                        <div class="feature-info">
                            <h3>Customizes Your Route</h3>
                            <p>Once you've chosen and selected multiple locations in your route, you'll be able to open it up and edit it directly in app. You can delete locations by swiping, and you can change the order by dragging and dropping accordingly.</p>
                        </div>
                    </div>

                    <div class="features-list wow fadeInRight">
                        <div class="icon">
                            <i class="fa fa-sun-o" aria-hidden="true"></i>
                        </div>
                        <div class="feature-info">
                            <h3>Directions</h3>
                            <p>Don't sweat the small stuff. We've got you covered. Use our app to GPS common places of interest while traveling through holy cities and towns. We know where it's at, and we'll get you there STAT.</p>
                        </div>
                    </div>

                    <div class="features-list wow fadeInRight">
                        <div class="icon">
                            <i class="fa fa-map" aria-hidden="true"></i>
                        </div>
                        <div class="feature-info">
                            <h3>Optimize Your Route</h3>
                            <p>We're so thrilled to offer you our awesome algorithm-based feature that will allow you to truly optimize your travel plans. Once you have a set route, you'll be able to click a button that will automatically re-arrange your selections and put them in the order that is most time-optimally-efficient!</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</section>
<!-- End How It Works -->
<!-- Start Fun Facts -->
<section id="fun-facts" class="parallax-bg section-padding" style="background-image:url(../../../assets/img/bg/fun-facts.jpg);">
    <div class="container">
        <div class="row">
            <div class="col-sm-4">
                <div class="fun-facts-info wow fadeInUp">
                    <div class="icon-4" style="font-size:500%; color:#f47c2a;"></div>
                    <span class="counter">{{count.bh}}</span>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="fun-facts-info wow fadeInUp">
                    <div class="icon-2" style="font-size:500%; color:#f47c2a;"></div>
                    <span class="counter">{{count.tz}}</span>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="fun-facts-info wow fadeInUp">
                    <div class="icon-1" style="font-size:500%; color:#f47c2a;"></div>
                    <span class="counter">{{count.bhm}}</span>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Fun Facts -->
<!-- Start Screenshots -->
<section id="screenshots" class="section-padding">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="section-title text-center">
                    <h1>Screenshots</h1>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-lg-10 col-lg-offset-1">
                <div class="screenshot-carousel" data-carousel-3d>
                    <img src="../../../assets/img/screenshot/1.jpg" alt="">
                    <img src="../../../assets/img/screenshot/2.jpg" alt="">
                    <img src="../../../assets/img/screenshot/3.jpg" alt="">
                    <img src="../../../assets/img/screenshot/4.jpg" alt="">
                    <img src="../../../assets/img/screenshot/5.jpg" alt="">
                    <img src="../../../assets/img/screenshot/6.png" alt="">
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Screenshots -->
<!-- Start Testimonials -->
<section id="testimonials" class="parallax-bg section-padding" style="background-image:url(../../../assets/img/bg/testimonials.jpg);">
    <div class="container">
        <div class="row">
            <div id="testimonial-carousel" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                  <div class="carousel-item item active">
                    <i class="fa fa-quote-left"></i>
                    <div class="author-comments">
                        <p>
                            This app is amazing. I just used it on my 2-day trip to קערסטיר and it was
                            wonderfully. Dear developer thank you very much it makes going to קברי
                            צדיקים easy and convenient.
                        </p>
                    </div>

                    <div class="author-rating">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                    </div>
                    <div class="author-img">
                        <!--<img src="/Ymm/img/testimonials/1.png" alt="" />-->
                    </div>
                    <div class="author-bio">
                        <span class="author-name">Yisroel Menchem Rosenberg</span>
                        <!--<span class="designation">CEO</span>-->
                    </div>
                
                  </div>
                  <div class="carousel-item item">
                    <i class="fa fa-quote-left"></i>
                    <div class="author-comments">
                        <p>I just use this app for my recent trip,  the information in the app is accurate and amazing, The app is very easy to use and mobile friendly!! Thanks</p>
                    </div>

                    <div class="author-rating">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                    </div>
                    <div class="author-img">
                        <!--<img src="/Ymm/img/testimonials/2.png" alt="" />-->
                    </div>
                    <div class="author-bio">
                        <span class="author-name">Yoel G</span>
                        <!--<span class="designation">Learner</span>-->
                    </div>
                  </div>
                  <div class="carousel-item item">
                    <i class="fa fa-quote-left"></i>
                    <div class="author-comments">
                        <p>Just an amazing collection from all point of interests so easy to search and compile a route. A great app.</p>
                    </div>

                    <div class="author-rating">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <!--<i class="fa fa-star-half-o"></i>-->
                        <i class="fa fa-star"></i>
                    </div>
                    <div class="author-img">
                        <!--<img src="/Ymm/img/testimonials/1.png" alt="" />-->
                    </div>
                    <div class="author-bio">
                        <span class="author-name">Manny Hartman</span>
                        <!--<span class="designation">CEO</span>-->
                    </div>
                  </div>
                  <div class="carousel-item item">
                    <i class="fa fa-quote-left"></i>
                            <div class="author-comments">
                                <p>
                                    This app is amazing
                                    A Beautiful job
                                    Thanks for the נדבן who sponsored to develop this helpful app
                                </p>
                            </div>

                            <div class="author-rating">
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                            </div>
                            <div class="author-img">
                                <!--<img src="../../../assets/img/testimonials/1.png" alt="" />-->
                            </div>
                            <div class="author-bio">
                                <!--<span class="author-name">Manny Hartman</span>-->
                                <!--<span class="designation">CEO</span>-->
                            </div>
                  </div>
                  <div class="carousel-item item">
                     <i class="fa fa-quote-left"></i>
                            <div class="author-comments">
                                <p>With this app you can now go on מקומות קדושים בהרחוות הדעת and specially when they are keeping it updated with a needs</p>
                            </div>

                            <div class="author-rating">
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                            </div>
                            <div class="author-img">
                                <!--<img src="../../../assets/img/testimonials/1.png" alt="" />-->
                            </div>
                            <div class="author-bio">
                                <!--<span class="author-name">Manny Hartman</span>-->
                                <!--<span class="designation">CEO</span>-->
                            </div>
                  </div>
                </div>
                <ol class="carousel-indicators">
                    <li data-bs-target="#testimonial-carousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></li>
                    <li data-bs-target="#testimonial-carousel" data-bs-slide-to="1" aria-label="Slide 2"></li>
                    <li data-bs-target="#testimonial-carousel" data-bs-slide-to="2" aria-label="Slide 3"></li>
                    <li data-bs-target="#testimonial-carousel" data-bs-slide-to="3" aria-label="Slide 4"></li>
                    <li data-bs-target="#testimonial-carousel" data-bs-slide-to="4" aria-label="Slide 5"></li>
                  </ol>
              </div>
        </div>
    </div>
</section>
<!-- End Testimonials -->

<section id="download" class="section-padding">
    <div class="container">
        <div class="row">
            <div class="section-title text-center">
                <h1>Download</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-sm-6">
                <div class="download-info wow fadeInLeft">
                    <h2>Get it for free</h2>
                    <p>Thanks to sponsorships and the kindness of the people behind this app, Nesiya Tova is being offered up at no cost. We encourage holy travel, and we want to help ease the way. Join us on this journey, with prayers for the final destination - all of us, together to Yerushalayim.</p>
                    <div class="download-link">
                        <a href="https://itunes.apple.com/us/app/nesiya-tova/id1280470476?mt=8" class="btn btn-default"><i class="fa fa-apple"></i> App Store</a>
                        <a href="http://play.google.com/store/apps/details?id=com.NesiyaTova" class="btn btn-default"><i class="fa fa-play"></i> Google Play</a>
                    </div>
                    <p style="margin-top:25px;"><b style="color:#f47c2a">New!</b><br />Our beautiful app is now available also in web format for your convenience.</p>
                    <div class="download-link">
                        <a routerLink="/ads"  class="btn btn-default"><i class="fa fa-cloud"></i> ADS</a>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6">
                <div class="single-img wow fadeInRight">
                    <img src="../../../assets/img/download/1.png" alt="" />
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Start Subscribe -->
<section id="subscribe" class="section-padding parallax-bg" style="background-image:url(../../../assets/img/bg/newsletter.jpg);">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xs-12 col-sm-10 col-md-8 col-sm-offset-1 col-md-offset-2">
                <div class="subscribe-content text-center">
                    <h1>Subscribe &amp; get amazing updates</h1>
                    <p>Don't worry, we won't send spam!</p>
                    <form id="mailingForm">
                        <!--method="post" type="submit"-->
                        <div class="input-group">
                            <input name="email" type="email" class="form-control" placeholder="Enter your email">
                            <span class="input-group-addon">
                                <input (click)="emailSubscribe()" type="submit" class="btn btn-default" value="subscribe">
                            </span>
                        </div>
                    </form>
                    <span class="help-block" [style.color]="isError ? 'red': 'green'" style="font-size:25px;">
                        {{error}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Subscribe -->
<!-- Start Contact Us -->
<section id="contact-us" class="section-padding">
    <div class="container">
        <div class="row">
            <div class="section-title text-center">
                <h1>Get in touch</h1>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-xs-12 col-md-8 col-md-offset-2">

                <!--<div class="contact-form">
                    <form id="contactForm" data-toggle="validator" method="post">
                        <div class="row">
                            <div class="col-sm-12 col-sm-6">
                                <div class="form-group">
                                    <input placeholder="First Name" id="fname" class="form-control" name="fname" type="text" required data-error="Please enter your first name">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-sm-6">
                                <div class="form-group">
                                    <input placeholder="Last Name" id="lname" class="form-control" name="lname" type="text">
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <input placeholder="Email Address" id="email" class="form-control" name="email" type="email" required data-error="Please enter your valid email address">
                            <div class="help-block with-errors"></div>
                        </div>

                        <div class="form-group">
                            <textarea placeholder="Your Comments" id="message" cols="20" rows="6" class="form-control" required data-error="Please enter your comments"></textarea>
                            <div class="help-block with-errors"></div>
                        </div>
                        <input value="Submit" name="submit" class="btn btn-default" type="submit">
                        <div id="msgSubmit" class="h3 text-center hidden"></div>
                    </form>
                </div>-->

                <h3>
                    To help us improve our app data,
                    please send us any additional info you have.
                    For example: new POI, places, a picture of a מצבה, or שומר info. etc.<br>
                    <a href="mailto:info.nesiyatova@gmail.com">info.nesiyatova&#64;gmail.com</a>
                </h3>
                <h3>
                    For any other comments or suggestions about the app,
                    feel free to contact
                    our developing team at:<br>
                    <a href="mailto:developer@nesiyatova.com">developer&#64;nesiyatova.com</a>
                </h3>




            </div>
        </div>
    </div>
</section>
<!-- End Contact Us -->

<footer>
    <div class="container">
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <div class="footer-content text-center">
                        <div class="footer-logo">
                            <img src="../../../assets/img/logo.png" alt="" />
                        </div>
                        <div class="copyright">
                            <p>&copy;copyright 2017 Nesiya Tova | All right reserved.</p>
                            <!--<a href="http://www.ymmmarketing.com/">Designed by YMM Marketing Corp.</a>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>

<!-- Bact to top -->
<div class="back-top">
    <a href="#"><i class="fa fa-angle-up"></i></a>
</div>



